export default __webpack_public_path__ + "static/media/unicornEmbossDark.76cdd4c5.png";